import axios from "axios";

const TOKEN = process.env.REACT_APP_SUREPASS_TOKEN;

async function getPAN_cardDetails(panCardNumber) {

    const response = await axios.post("https://kyc-api.aadhaarkyc.io/api/v1/pan/pan", { "id_number": panCardNumber }, {
        headers: { Authorization: `Bearer ${TOKEN}` }
    })

    return response;
}
async function getAccountDetails(postBody) {
    console.log({ postBody });
    const response = await axios.post("https://kyc-api.aadhaarkyc.io/api/v1/bank-verification/", postBody, {
        headers: { Authorization: `Bearer ${TOKEN}` }
    })

    return response;
}
async function getAadharCardDetails(aadharNumber) {
    const response = await axios.post("https://kyc-api.aadhaarkyc.io/api/v1/aadhaar-validation/aadhaar-validation", {
        "id_number": aadharNumber
        // ,"less_info":true                // ! commented this on 13 Apr, 2023 => verification failed for 461582983626 ==> Client issue fix
    }, {
        headers: { Authorization: `Bearer ${TOKEN}` }
    })

    return response;
}
async function getGSTNumber(panCardNumber) {
    const response = await axios.post("https://kyc-api.aadhaarkyc.io/api/v1/corporate/gstin-by-pan", { "id_number": panCardNumber }, {
        headers: { Authorization: `Bearer ${TOKEN}` }
    })

    return response;
}
async function getGSTInfo(gstNumber) {
    const response = await axios.post("https://kyc-api.aadhaarkyc.io/api/v1/corporate/gstin", { "id_number": gstNumber, "filing_status_get": true }, {
        headers: { Authorization: `Bearer ${TOKEN}` }
    })

    return response;
}
// async function getReraDetails(reraNumber) {
//     const response = await axios.post("https://kyc-api.aadhaarapi.io/api/v1/rera/verify-agent", { "id_number": reraNumber }, {
//         headers: { Authorization: `Bearer ${TOKEN}` }
//     })

//     return response;
// }
async function getReraDetails(reraNumber) {
    const response = await axios.post("https://kyc-api.aadhaarapi.io/api/v1/rera/rera-v2", { 
    "registration_number": reraNumber ,
    "registration_type": "agent",
    "state_name": "maharashtra"
     }, {
        headers: { Authorization: `Bearer ${TOKEN}` }
    })

    return response;
}
export { getPAN_cardDetails, getAccountDetails, getAadharCardDetails, getGSTNumber, getGSTInfo, getReraDetails }